import {
  formatFullFavoritesCount,
  getDeterministicFavoritesByProductId,
} from 'src/utils/restructure/getDeterministicFavoritesByProductId'

type FavoritesCounterFullProps = {
  productId?: string | number
}

export default function FavoritesCounterFull({
  productId,
}: Readonly<FavoritesCounterFullProps>) {
  const normalizedProductId = String(productId ?? '').trim()

  if (!normalizedProductId) {
    return null
  }

  const favoritesCount = getDeterministicFavoritesByProductId(productId)
  const fullValue = formatFullFavoritesCount(favoritesCount)

  return (
    <p
      data-dy-id="favorites-counter-pdp"
      className="hidden mt-4 items-center gap-2 text-[#3643ba]"
    >
      <svg
        aria-hidden="true"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="currentColor"
        className="shrink-0"
      >
        <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09A6.01 6.01 0 0116.5 3C19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
      </svg>

      <span className="text-sm font-semibold">
        {fullValue} pessoas favoritaram este produto
      </span>
    </p>
  )
}
